import React from 'react';
import Translate, {t} from "../../../components/Translate";

const ImportForm = ({isVisible, importData, setImportData, handleImportSubmit, currentUser, close}) => {

    if (!isVisible) return null;

    return (
        <div className="modal-overlay" onClick={close}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3><Translate language={currentUser.language} text="importResourceData"/></h3>
                <div>
                    <textarea
                        className="import-textarea"
                        placeholder={t(currentUser.language, "pasteYourResourceDataHere")}
                        value={importData}
                        onChange={(e) => setImportData(e.target.value)}
                    />
                    <button className="modal-button cancel" onClick={close}>
                        <Translate language={currentUser.language} text="close"/>
                    </button>
                    <button className="modal-button confirm"
                            onClick={() => {
                                handleImportSubmit();
                                close();
                            }}>
                        <Translate language={currentUser.language} text="submit"/>
                    </button>
                </div>

            </div>
        </div>
    )
};

export default ImportForm;
